import {
  BRAND_OG_IMAGE_PATH,
  BRAND_STRUCTURED_DATA_LOGO_PATH,
} from '../../lib/brand';

export const SITE_URL = 'https://belahora.io';
export const DEFAULT_OG_IMAGE_PATH = BRAND_OG_IMAGE_PATH;
const ORGANIZATION_LOGO_PATH = BRAND_STRUCTURED_DATA_LOGO_PATH;

export const LANDING_TITLE =
  'BelaHora | Marcações e operação para salões nos Açores';
export const LANDING_DESCRIPTION =
  'Sistema para salões, barbearias e clínicas de estética nos Açores. Setup em 48h, lembretes anti-faltas, marcação online e acompanhamento local desde 29€/mês.';

export const LANDING_FAQ_ENTRIES = [
  {
    question: 'Como funciona a garantia de resultado?',
    answer:
      'Ativamos os lembretes automáticos e, no final do primeiro mês, verificamos se o sistema evitou pelo menos uma falta no valor da tua mensalidade. Se não, o segundo mês é grátis — sem precisares de pedir ou justificar. Funciona quer faças marcações online quer as registes manualmente.',
  },
  {
    question: 'O que acontece depois de pedir a auditoria gratuita?',
    answer:
      'Entramos em contacto em menos de 24h para uma videochamada de 30 minutos. Olhamos para o teu caso com contexto, percebemos onde está o maior desperdício e mostramos se e como o BelaHora faz sentido para ti. Sem pressão de venda.',
  },
  {
    question: 'Porque não há trial grátis?',
    answer:
      'Porque um trial sem setup não mostra nada de útil. Preferimos fazer a configuração completa e garantir que arrancas a receber marcações. A garantia de resultado é o nosso equivalente ao trial — mas sem risco para ti.',
  },
  {
    question: 'O apoio é mesmo local?',
    answer:
      'Sim. Não tens um ticket aberto para uma equipa em Lisboa ou no estrangeiro. Tens alguém nos Açores, que conhece o mercado local, disponível por videochamada, WhatsApp ou email.',
  },
  {
    question: 'Como tratam o RGPD e consentimento para campanhas?',
    answer:
      'O consentimento de contacto é recolhido automaticamente no momento da marcação. Campanhas de marketing exigem consentimento próprio e separado — que também gerimos. Estás sempre em conformidade.',
  },
] as const;

export const landingStructuredData = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'Organization',
      name: 'BelaHora',
      url: SITE_URL,
      logo: `${SITE_URL}${ORGANIZATION_LOGO_PATH}`,
      areaServed: {
        '@type': 'AdministrativeArea',
        name: 'Açores',
      },
    },
    {
      '@type': 'Service',
      serviceType: 'Infraestrutura operacional para salões e barbearias',
      name: 'BelaHora',
      provider: {
        '@type': 'Organization',
        name: 'BelaHora',
        url: SITE_URL,
      },
      areaServed: {
        '@type': 'AdministrativeArea',
        name: 'Açores',
      },
      audience: {
        '@type': 'Audience',
        audienceType:
          'Donos de salões, barbearias e clínicas de estética com equipas pequenas',
      },
      description: LANDING_DESCRIPTION,
      offers: {
        '@type': 'Offer',
        price: '29',
        priceCurrency: 'EUR',
        availability: 'https://schema.org/InStock',
        url: SITE_URL,
        description:
          'Desde 29€/mês com setup feito por nós em 48 horas, marcação online, lembretes anti-faltas e garantia de resultado: se não evitarmos pelo menos uma falta no valor da mensalidade no primeiro mês, o segundo mês é grátis.',
      },
    },
    {
      '@type': 'Offer',
      name: 'Plano Essencial BelaHora',
      price: '29',
      priceCurrency: 'EUR',
      availability: 'https://schema.org/InStock',
      url: SITE_URL,
      category: 'SoftwareService',
      description:
        'Entrada desde 29€/mês com setup feito por nós em 48 horas e garantia de resultado: se o sistema não se pagar no primeiro mês, o segundo mês é grátis.',
    },
    {
      '@type': 'FAQPage',
      mainEntity: LANDING_FAQ_ENTRIES.map((entry) => ({
        '@type': 'Question',
        name: entry.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: entry.answer,
        },
      })),
    },
  ],
} as const;
